import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { RoleAuthorizationService } from './core/role-authorization.service';

@Component({
  selector: 'app-unauthorized-page',
  standalone: true,
  imports: [RouterLink],
  template: `
    <section class="authorization-page" aria-labelledby="authorization-title">
      <p class="authorization-page__eyebrow">Access restricted</p>
      <h1 id="authorization-title">You do not have access to this area.</h1>
      <p>
        Your signed-in account does not include the role required for the requested Hub Central route.
      </p>
      @if (dashboardPath) {
        <a class="ds-c-button ds-c-button--solid" [routerLink]="dashboardPath">Go to my dashboard</a>
      }
    </section>
  `,
  styles: [`
    .authorization-page {
      max-width: 48rem;
      padding: 2rem;
    }

    .authorization-page__eyebrow {
      margin: 0 0 .5rem;
      font-weight: 700;
      text-transform: uppercase;
    }
  `],
})
export class UnauthorizedPage {
  private readonly authorization = inject(RoleAuthorizationService);
  private readonly role = this.authorization.defaultRole();

  protected readonly dashboardPath = this.role ? `/${this.role}/dashboard` : null;
}
